import { v4 } from 'uuid';
import 'js-cookie';
import 'dayjs';

var API_NAME;
(function (API_NAME) {
    API_NAME["USER_GET_INFO"] = "user.getInfo";
    API_NAME["EVENT_BUS"] = "event-bus";
    API_NAME["GET_LANGUAGE"] = "getLanguage";
    API_NAME["GET_WORKSPACE_QUOTA"] = "account.getWorkspaceQuota";
    API_NAME["GET_HOST_CONFIG"] = "getHostConfig";
})(API_NAME || (API_NAME = {}));

var EVENT_NAME;
(function (EVENT_NAME) {
    EVENT_NAME["GET_APPS"] = "get-apps";
    EVENT_NAME["CHANGE_I18N"] = "change_i18n";
})(EVENT_NAME || (EVENT_NAME = {}));

const isBrowser = () => typeof window !== 'undefined';

class ClientSDK {
    eventBus = new Map();
    initialized = false;
    desktopOrigin = '*';
    commonConfig = {
        appKey: '',
        clientLocation: '',
        success: false
    };
    userSession;
    callback = new Map();
    apiFun = {
        [API_NAME.EVENT_BUS]: (data) => this.runAppEvents(data)
    };
    sendMessageToMaster(apiName, data = {}, needReply = true) {
        if (!this.initialized)
            return Promise.reject('APP is uninitialized');
        const messageId = v4();
        /* Equivalent to a response */
        const cb = new Promise((resolve, reject) => {
            if (needReply) {
                /* timeout */
                const timer = setTimeout(() => {
                    this.callback.delete(messageId);
                    reject('timeout');
                }, 10000);
                this.callback.set(messageId, (data) => {
                    clearTimeout(timer);
                    if (data.success) {
                        resolve(data.data);
                    }
                    else {
                        reject(data);
                    }
                });
            }
            else {
                resolve('');
            }
        });
        /* Equivalent to a request */
        const sendMessage = {
            messageId,
            apiName,
            ...this.commonConfig,
            data
        };
        window.top?.postMessage(sendMessage, this.desktopOrigin);
        return cb;
    }
    init() {
        console.log('sealos app init');
        this.commonConfig.clientLocation = window.location.origin;
        const listenCb = ({ data, origin, source }) => {
            const { apiName, messageId } = data || {};
            if (!source)
                return;
            if (apiName && this?.apiFun[data?.apiName]) {
                return this.apiFun[data.apiName](data);
            }
            if (messageId && this.callback.has(data?.messageId)) {
                this.desktopOrigin = origin;
                // @ts-ignore nextline
                this.callback.get(data.messageId)(data);
                this.callback.delete(data?.messageId);
            }
        };
        /* add message listen to top */
        window.addEventListener('message', listenCb);
        this.initialized = true;
        return () => {
            console.log('sealos app destroy');
            window.removeEventListener('message', listenCb);
        };
    }
    getSession() {
        if (this.userSession) {
            return Promise.resolve(this.userSession);
        }
        return this.sendMessageToMaster(API_NAME.USER_GET_INFO);
    }
    getLanguage() {
        return this.sendMessageToMaster(API_NAME.GET_LANGUAGE);
    }
    getWorkspaceQuota() {
        return this.sendMessageToMaster(API_NAME.GET_WORKSPACE_QUOTA);
    }
    getHostConfig() {
        return this.sendMessageToMaster(API_NAME.GET_HOST_CONFIG);
    }
    /**
     * run master EventBus
     */
    runEvents(eventName, eventData) {
        return this.sendMessageToMaster(API_NAME.EVENT_BUS, {
            eventName,
            eventData
        });
    }
    /**
     * add app event bus
     */
    addAppEventListen(name, fn) {
        if (this.eventBus.has(name)) {
            console.error('event bus name repeat');
            return;
        }
        if (typeof fn !== 'function') {
            console.error('event is not a function');
            return;
        }
        this.eventBus.set(name, fn);
        return () => this.removeAppEventListen(name);
    }
    /**
     * remove app event bus
     */
    removeAppEventListen(name) {
        this.eventBus.delete(name);
    }
    /**
     * run app event bus
     */
    runAppEvents(data) {
        if ('eventName' in data) {
            if (!this.eventBus.has(data.eventName)) {
                console.error('event bus name does not exist');
                return;
            }
            const eventFunction = this.eventBus.get(data.eventName);
            if (eventFunction) {
                eventFunction(data.data);
            }
        }
    }
}
/**
 * @deprecated - You really should not use sealosApp directly anymore. We will migrate to a React Context based approach in the near future.
 */
let sealosApp;
const createSealosApp = () => {
    if (!isBrowser()) {
        console.error('This method need run in the browser.');
        return;
    }
    sealosApp = new ClientSDK();
    return sealosApp.init();
};

export { createSealosApp, sealosApp };
